import React, { FC } from 'react';
import { Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import Site from '../../../../../interfaces/api/Site';

interface Props {
  site?: Site;
}

const SiteLink: FC<Props> = ({ site }) => {
  if (!site) {
    return <Skeleton width={50} />;
  }

  return (
    <>
      {`Site: `}
      <Link component={RouterLink} underline='always' to={`/dashboard/customer/${site.legacyCustomerId}`}>
        {site.socialReason}
      </Link>
    </>
  );
};

export default SiteLink;
